import { FC, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

import * as ROUTES from 'constants/paths';
import { useSubscriptionsPlansData } from 'constants/subscriptions';
import { isEmpty } from 'lodash';
import { useUserSubscriptionStore } from 'store/useUserSubscriptionStore';
import { getIsSubscriptionLoading, getUserSubscription } from 'store/useUserSubscriptionStore/selectors';

import { Button } from 'components/_basic/Button/Button';

import { trackPurchase } from './utils/trackPurchase';

import styles from './SuccessPaymentPage.module.scss';

const WORKSPACE_AFTER_PAYMENT = `${ROUTES.WORKSPACE}?newTarif=true`;

export const SuccessPaymentPage: FC = () => {
  const navigate = useNavigate();
  const [isAnalyticsReady, setIsAnalyticsReady] = useState(false);

  const userSubscription = useUserSubscriptionStore(getUserSubscription);
  const isSubscriptionLoading = useUserSubscriptionStore(getIsSubscriptionLoading);
  const subscriptionsPlansData = useSubscriptionsPlansData();

  useEffect(() => {
    if (isSubscriptionLoading) {
      return;
    }

    if (!isEmpty(userSubscription)) {
      trackPurchase(userSubscription.currentSubscription, subscriptionsPlansData);
    }

    setIsAnalyticsReady(true);
  }, [isSubscriptionLoading, subscriptionsPlansData, userSubscription]);

  const handleGoToWorkspace = () => {
    navigate(WORKSPACE_AFTER_PAYMENT, { replace: true });
  };

  return (
    <>
      <Helmet>
        <title>Thank you - Growexa</title>
      </Helmet>

      <main className={styles.page}>
        <div className={styles.card}>
          <div className={styles.check} aria-hidden="true">
            <svg
              className={styles.checkIcon}
              viewBox="0 0 24 24"
              fill="none"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 6 9 17l-5-5" />
            </svg>
          </div>

          <h1 className={styles.title}>Thank you for subscribing!</h1>
          <p className={styles.description}>Your payment was successful.</p>

          <Button
            className={styles.workspaceButton}
            variant="contained"
            fullWidth
            disabled={!isAnalyticsReady}
            onClick={handleGoToWorkspace}
          >
            Go to workspace
          </Button>

          <p className={styles.support}>
            Need help?{' '}
            <a className={styles.supportLink} href={`mailto:${ROUTES.CONTACT_US_MAIL}`}>
              Contact support
            </a>
          </p>
        </div>
      </main>
    </>
  );
};
